import { CustomField } from "../types";
import { createGenericFormSlice, SliceState } from "./genericFormSlice";

const formSlice = createGenericFormSlice({
  name: "customFieldOptionsTab",
  initialState: {} as SliceState<CustomField>,
  reducers: {},
});

export const { reset, initialize, updateField } = formSlice.actions;
const customFieldOptionsTabReducer = formSlice.reducer;
export default customFieldOptionsTabReducer;
